export default __webpack_public_path__ + "locales/ja-JP/DowngradePlanDialog.json?hash=57a69bfd133d6ee733d3683c86be5f94";